__turbopack_context__.v({
  "close": "YouTubeVideo-module-scss-module__P31Gea__close",
  "container": "YouTubeVideo-module-scss-module__P31Gea__container",
  "content": "YouTubeVideo-module-scss-module__P31Gea__content",
  "control": "YouTubeVideo-module-scss-module__P31Gea__control",
  "dialog": "YouTubeVideo-module-scss-module__P31Gea__dialog",
  "icon": "YouTubeVideo-module-scss-module__P31Gea__icon",
  "image": "YouTubeVideo-module-scss-module__P31Gea__image",
  "youtube": "YouTubeVideo-module-scss-module__P31Gea__youtube",
});
